// Mock data for Ginos Friseur Düsseldorf

export const salonInfo = {
  name: "Ginos Friseure Düsseldorf",
  motto: "Wo Schönheit ihre Form findet",
  tagline: "Erstklassige Friseurkunst in Düsseldorf Pempelfort & Derendorf",
  address: {
    street: "Parkstraße 4",
    district: "Pempelfort",
    city: "Düsseldorf",
    postalCode: "40477",
    country: "Deutschland"
  },
  contact: {
    instagram: "https://www.instagram.com/ginosfriseuredusseldorf",
    treatwell: "https://www.treatwell.de/ort/ginos-friseure-duesseldorf/",
    googleMaps: "https://www.google.com/maps/search/?api=1&query=Parkstraße+4+Pempelfort+40477+Düsseldorf"
  },
  hours: {
    monday: "Geschlossen",
    tuesday: "09:00–17:00",
    wednesday: "09:00–18:00",
    thursday: "09:00–18:00",
    friday: "09:00–21:00",
    saturday: "08:00–14:00",
    sunday: "Geschlossen"
  },
  rating: 4.9,
  reviewCount: 47
};

export const services = [
  {
    id: 1,
    title: "Haarschnitte & Styling",
    description: "Perfekte Schnitte für jeden Look",
    image: "https://images.unsplash.com/photo-1712641970791-ea9a566c93bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwaGFpciUyMHN0eWxpbmd8ZW58MHx8fHwxNzcxNjk3OTA2fDA&ixlib=rb-4.1.0&q=85",
    priceFrom: "45€"
  },
  {
    id: 2,
    title: "Farbe & Coloration",
    description: "Lebendige Farben und natürliche Töne",
    image: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/3zp8xyy1_IMG_1703.jpg",
    priceFrom: "30€"
  },
  {
    id: 3,
    title: "Balayage & Strähnen",
    description: "Natürliche Akzente und Highlights",
    image: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/z672kpgy_IMG_1704.jpg",
    priceFrom: "65€"
  },
  {
    id: 4,
    title: "Haarverlängerung",
    description: "Volumen und Länge nach Wunsch",
    image: "https://images.unsplash.com/photo-1570653190385-fe560c6e56d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYWlyJTIwZXh0ZW5zaW9uc3xlbnwwfHx8fDE3NzE2OTc4OTl8MA&ixlib=rb-4.1.0&q=85",
    priceFrom: "250€"
  },
  {
    id: 5,
    title: "Haarkuren & Pflege",
    description: "Intensive Pflege für gesundes Haar",
    image: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/vhx6ohb3_Evo_2_b2c0cdf5-6a92-4366-8eaa-bd1973d216d6.webp",
    priceFrom: "20€"
  },
  {
    id: 6,
    title: "Föhnen & Styling",
    description: "Professionelles Finish für jeden Anlass",
    image: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/s31dkbjr_IMG_1701.jpg",
    priceFrom: "38€"
  }
];

export const priceHighlights = [
  {
    category: "Damen Highlights",
    services: [
      { name: "Waschen Schneiden Föhnen", price: "ab 66€", duration: "40-60 Min" },
      { name: "Balayage Schnitt Föhnen", price: "ab 240€", duration: "180 Min" },
      { name: "Strähnen ganzer Kopf", price: "ab 90€", duration: "120 Min" }
    ]
  },
  {
    category: "Herren Highlights",
    services: [
      { name: "Waschen Schneiden Föhnen", price: "ab 45€", duration: "30-60 Min" },
      { name: "Grauhaar Kaschierung", price: "30€", duration: "40 Min" }
    ]
  },
  {
    category: "Spezialbehandlungen",
    services: [
      { name: "Haarverlängerung", price: "ab 250€", duration: "180 Min" },
      { name: "Olaplex Behandlung", price: "20€", duration: "30 Min" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mina",
    text: "Paintings kann ich bei ihm nur sehr empfehlen!",
    service: "Strähnen ganzer Kopf",
    rating: 5
  },
  {
    id: 2,
    name: "Julian",
    text: "Das erste Mal hier gewesen und es lief dennoch alles perfekt. Vielen Dank für den tollen Haarschnitt.",
    service: "Herrenhaarschnitt",
    rating: 5
  },
  {
    id: 3,
    name: "Mannus",
    text: "Gino hat mir einen guten Haarschnitt gemacht, es gab auch Kaffee und etwas süßes, gerne wieder 👍",
    service: "Herrenhaarschnitt",
    rating: 5
  },
  {
    id: 4,
    name: "Detlef",
    text: "Tolle Salon und nette Leute, toller Haarschnitt",
    service: "Herrenhaarschnitt",
    rating: 5
  }
];

export const galleryImages = [
  // Hair Styling Results - Real Salon Photos
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/s31dkbjr_IMG_1701.jpg",
    alt: "Dunkles glattes Haar Styling",
    category: "styling"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/6rwpmeju_IMG_1702.jpg",
    alt: "Blonde Balayage Front View",
    category: "styling"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/3zp8xyy1_IMG_1703.jpg",
    alt: "Blonde Strähnen Styling",
    category: "styling"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/z672kpgy_IMG_1704.jpg",
    alt: "Blonde Balayage Back View",
    category: "styling"
  },
  // Salon Interior Photos
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/n3ean0ek_Picture%201.jpg",
    alt: "Salon Eingang mit Produktregal",
    category: "salon"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/p9btz9a1_Picture%202.jpg",
    alt: "Styling-Bereich mit LED-Spiegeln",
    category: "salon"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/04wahxbp_Picture%203.jpg",
    alt: "Schaufenster mit Logo",
    category: "salon"
  },
  // Wash Basin Area
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/me26hvx8_C68839A8-3E1D-403C-B41E-542738A503D4.jpg",
    alt: "Waschbereich mit schwarzen Waschbecken",
    category: "salon"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/l81y2qrf_2CB4E27A-C7B7-4959-B5D5-E2E977C9EB04.PNG",
    alt: "Waschbecken Detail",
    category: "salon"
  },
  // Evo Products
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/vhx6ohb3_Evo_2_b2c0cdf5-6a92-4366-8eaa-bd1973d216d6.webp",
    alt: "Evo Hair Care Produkt",
    category: "products"
  },
  // Additional Real Salon Styling Photos
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/y4f47zmh_IMG_1701.jpg",
    alt: "Hair Color Service Result",
    category: "styling"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/r6apmp8b_IMG_1702.jpg",
    alt: "Blonde Hair Styling",
    category: "styling"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/8lokh0px_IMG_1703.jpg",
    alt: "Balayage Hair Result",
    category: "styling"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/ohe00vfo_b53064b4-65ff-4de5-a96a-12fe5ac7ca4a.JPG",
    alt: "Hair Extensions Result",
    category: "styling"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_ginos-duesseldorf/artifacts/infjb75l_8F1B45A2-8FDE-4FCA-89C1-8C774310B634.JPG",
    alt: "Long Hair Styling",
    category: "styling"
  }
];

export const aboutText = {
  heading: "Ihr Premium Friseur in Düsseldorf Pempelfort",
  description: "Willkommen bei Ginos Friseure – Ihr erstklassiger Friseur in Düsseldorf Pempelfort und Derendorf. Wir sind Ihre Top-Adresse für professionelle Friseurdienstleistungen und Stylings in Düsseldorf. Lass dich von unserem erfahrenen Team beraten und gönne dir ein neues Styling oder lasse deinen Haarschnitt & deine Haarfarbe auffrischen.",
  team: "Als erfahrener Friseur in Pempelfort und Derendorf besteht unser Team aus leidenschaftlichen Profis, die es dir mit ihrer freundlichen und zuvorkommenden Art leicht machen, dich sofort wohl zu fühlen. Du wirst unseren Salon in Düsseldorf garantiert mit neuem Selbstbewusstsein wieder verlassen."
};
